import * as React from "react";
import { Button, Modal } from "react-ui";

import { ensureNotNullOrUndefined } from "../../../../../../Common/TypingUtils";
import { sizeToken } from "../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { DataDeclarationFactory, ValidationFunctionsFactory } from "../../../../Forms/RawFormResources";
import { NidusEntryData } from "../../../../../../Common/NidusClient/INidusClient";
import { DraftFullId } from "../../../../../../Common/CandyApiClient/Types/DraftFullId";
import { InlineFormContainer } from "../SelectNidusEntryModal/CreateNidusEntryFormModalProps.styles";
import { AutocalculationConfigurator } from "../../../../Forms/FormResources";

import { InlineForm, InlineFormHandler } from "./InlineForm/InlineForm";

interface NidusEntryDataModalEditorProps {
    editor: React.ReactNode;
    editorValidations: ValidationFunctionsFactory;
    kcXmlValidationConfigurator: AutocalculationConfigurator;
    editorDataDeclaration: DataDeclarationFactory;
    initialData: NidusEntryData;
    title: React.ReactNode;
    draftId: DraftFullId;
    keformsUrl: string;
    onApplyData: (nidusEntryData: NidusEntryData) => Promise<void>;
    onClose: () => void;
}

export function NidusEntryDataModalEditor(props: NidusEntryDataModalEditorProps): JSX.Element {
    const createEntryFormRef = React.useRef<InlineFormHandler>(null);
    const [entryCreating, setEntryCreating] = React.useState(false);

    const handleCreateEntryFormSave = async () => {
        if (entryCreating) {
            return;
        }
        ensureNotNullOrUndefined(createEntryFormRef.current);
        if (!createEntryFormRef.current.isFormDataValid()) {
            const focusResult = await createEntryFormRef.current.focusFirstInvalidControl();
            if (focusResult) {
                // В общем, это костыль: на форме могут быть скрытые контролы и мы пока не умеем понимать что они скрыти и
                // "типа" на должны влиять на валидность формы. Дело даже в том что тут нет ясности как правильно такое делать
                // focusResult == true в том случае если на форме нашелся таки невалидный контрол
                return;
            }
        }
        setEntryCreating(true);
        const newEntryData = createEntryFormRef.current.getFormData();
        await props.onApplyData(newEntryData);
    };

    return (
        <Modal ignoreBackgroundClick onClose={props.onClose} disableClose={entryCreating}>
            <Modal.Header>{props.title}</Modal.Header>
            <Modal.Body>
                <InlineFormContainer overlay={entryCreating}>
                    <InlineForm
                        data-tid="EditEntryForm"
                        ref={createEntryFormRef}
                        parentDraftId={props.draftId}
                        parentKeformsUrl={props.keformsUrl}
                        initialData={props.initialData}
                        validationFunctions={props.editorValidations}
                        kcXmlValidationConfigurator={props.kcXmlValidationConfigurator}
                        dataDeclaration={props.editorDataDeclaration}>
                        {props.editor}
                    </InlineForm>
                </InlineFormContainer>
            </Modal.Body>
            <Modal.Footer panel>
                <Button
                    data-tid="Save"
                    use="primary"
                    size="medium"
                    onClick={handleCreateEntryFormSave}
                    disabled={entryCreating}
                    loading={entryCreating}>
                    Сохранить
                </Button>
                <span style={{ display: "inline-block", width: sizeToken(1) }} />
                <Button data-tid="Cancel" size="medium" onClick={props.onClose} disabled={entryCreating}>
                    Отменить
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
